const writeWithClipboardApi = async (value: string) => {
  try {
    await navigator.clipboard.writeText(value);
    return true;
  } catch {
    return false;
  }
};

const writeWithTextarea = (value: string) => {
  const holder = document.createElement('textarea');
  const container =
    document.activeElement?.closest('[role="dialog"], [role="alertdialog"]') ??
    document.body;

  holder.value = value;
  holder.setAttribute('readonly', '');
  holder.style.position = 'fixed';
  holder.style.opacity = '0';
  container.appendChild(holder);
  holder.select();

  try {
    return document.execCommand('copy');
  } catch {
    return false;
  } finally {
    container.removeChild(holder);
  }
};

export const copyText = async (value: string): Promise<boolean> => {
  if (window.isSecureContext && (await writeWithClipboardApi(value))) {
    return true;
  }

  return writeWithTextarea(value);
};
